import React from 'react';
import { Quote, Star } from 'lucide-react';

const testimonials = [
  {
    quote:
      'AinaSuite replaced two support tools and a Zapier mess. Our WhatsApp lead replies went from 4 hours to instant — and our team finally gets to sleep.',
    name: 'Aisha Rahman',
    role: 'Head of Growth',
    company: 'Yogurt Planet',
    avatarBg: '#06b6ec',
    initials: 'AR',
    rating: 5,
  },
  {
    quote:
      'Dispatch queries used to flood our inbox every morning. Now the AI answers driver and customer questions instantly across WhatsApp and our web chat.',
    name: 'Marcus Liu',
    role: 'Operations Lead',
    company: 'T&L',
    avatarBg: '#8b5cf6',
    initials: 'ML',
    rating: 5,
  },
  {
    quote:
      'Setting up the knowledge base took 20 minutes — Drive sync, our enterprise product catalogue, support SLAs. The agent sounded like one of our reps from day one.',
    name: 'Priya Singh',
    role: 'VP Customer Success',
    company: 'Vantro',
    avatarBg: '#22c55e',
    initials: 'PS',
    rating: 5,
  },
  {
    quote:
      'The visual CRM is the killer feature. Every Instagram DM becomes a tracked lead with intent tags — our sales team just works the pipeline now.',
    name: 'David Okafor',
    role: 'Marketing Director',
    company: 'TLC',
    avatarBg: '#f97316',
    initials: 'DO',
    rating: 5,
  },
  {
    quote:
      'Appointment booking via Google Calendar saved us an admin hire. The AI checks real availability and confirms with the client in one chat — beautifully on-brand.',
    name: 'Sara Mendes',
    role: 'Studio Director',
    company: '1.618',
    avatarBg: '#ec4899',
    initials: 'SM',
    rating: 5,
  },
  {
    quote:
      'We connected MySQL on the Enterprise plan and the AI answers technical questions live with citations from our docs. Tickets dropped 38% in the first month.',
    name: 'Tomáš Novák',
    role: 'CTO',
    company: 'SIRAi',
    avatarBg: '#0ea5e9',
    initials: 'TN',
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="tmnl">
      <div className="container">
        <div className="tmnl__head reveal">
          <span className="eyebrow">Testimonials</span>
          <h2 className="tmnl__title">Loved by teams that talk to customers</h2>
          <p className="tmnl__desc">
            From food brands to logistics to AI studios — here's what AinaSuite is doing for them.
          </p>
        </div>

        <div className="tmnl__grid">
          {testimonials.map((t, i) => (
            <figure
              key={t.company}
              className="tmnlCard reveal"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <Quote size={22} className="tmnlCard__quote" />
              <div className="tmnlCard__stars" aria-label={`${t.rating} out of 5 stars`}>
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={14} fill="#f59e0b" stroke="#f59e0b" />
                ))}
              </div>
              <blockquote className="tmnlCard__quoteText">{t.quote}</blockquote>
              <figcaption className="tmnlCard__person">
                <span className="tmnlCard__avatar" style={{ background: t.avatarBg }}>
                  {t.initials}
                </span>
                <span>
                  <span className="tmnlCard__name">{t.name}</span>
                  <span className="tmnlCard__role">
                    {t.role} · {t.company}
                  </span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
